import React, { FunctionComponent, memo, useMemo } from 'react'
import clsx from 'clsx'
import styles from './TaskTabs.module.sass'
import { EMPTY_TASK, Task } from '../../../responses/tasks'
import { ID } from '../../../types/UtilityTypes'
import { useRootDispatch } from '../../../utils/hooks'
import { AnimatePresence, motion } from 'framer-motion'
import { urlWithParams } from '../../../http/utils'
import { ROUTES } from '../../../http/routes'
import { push } from 'connected-react-router'
import EditIcon from '../../../../files/edit.svg'
import TaskTab from './TaskTab'

const NewTask: Task = {
    ...EMPTY_TASK,
    type: {
        ...EMPTY_TASK.type,
        name: 'Новая задача'
    }
}

const initial = { width: 0, opacity: 0 }
const animate = { width: 30, opacity: 1 }

interface Props {
    className?: string,
    items: Task[],
    activeId: ID,
    editedId?: ID,
    append?: boolean,
    minimal?: boolean,
    onChange?: (item: ID) => void,
}

const TaskTabs: FunctionComponent<Props> = props => {
    const dispatch = useRootDispatch()
    const tasks = useMemo(() => {
        return props.items.concat(props.append ? NewTask : [])
    }, [props.items, props.append])

    return <div className={clsx(props.className, styles.tabs)}>
        <AnimatePresence>
            {
                tasks.map(task => <TaskTab
                    key={task.id}
                    task={task}
                    active={task.id == props.activeId}
                    onClick={() => task.id == props.activeId ?
                        (props.activeId !== 0 && dispatch(push(urlWithParams({ taskId: task.id })(ROUTES.TASK)))) :
                        props.onChange?.(task.id)
                    }
                >
                    <AnimatePresence>
                        {
                            props.editedId == task.id && <motion.div
                                key={'icon'}
                                className={styles.editIcon}
                                initial={initial}
                                animate={animate}
                                exit={initial}
                            >
                                <EditIcon/>
                            </motion.div>
                        }
                    </AnimatePresence>
                </TaskTab>)
            }
        </AnimatePresence>
    </div>
}

export default memo(TaskTabs)